import {
  EXPORT_SCHOOL,
  EXPORT_SCHOOL_FAILURE,
  EXPORT_SCHOOL_SUCCESS,
  EXPORT_STUDENT,
  EXPORT_STUDENT_FAILURE,
  EXPORT_STUDENT_SUCCESS,
  EXPORT_TEACHER,
  EXPORT_TEACHER_SUCCESS,
  EXPORT_TEACHER_FAILURE,
  RELOAD_SCHOOL_DETAIL
} from "../types";

export const exportTeacher = (payload) => ({
  type: EXPORT_TEACHER,
  payload,
});

export const exportTeacherSuccess = (payload) => ({
  type: EXPORT_TEACHER_SUCCESS,
  payload,
});

export const exportTeacherFailure = (payload) => ({
  type: EXPORT_TEACHER_FAILURE,
  payload,
});

export const exportSchool = (payload) => ({
  type: EXPORT_SCHOOL,
  payload,
});

export const exportSchoolSuccess = (payload) => ({
  type: EXPORT_SCHOOL_SUCCESS,
  payload,
});

export const exportSchoolFailure = (payload) => ({
  type: EXPORT_SCHOOL_FAILURE,
  payload,
});

export const exportStudent = (payload) => ({
  type: EXPORT_STUDENT,
  payload,
});

export const exportStudentSuccess = (payload) => ({
  type: EXPORT_STUDENT_SUCCESS,
  payload,
});

export const exportStudentFailure = (payload) => ({
  type: EXPORT_STUDENT_FAILURE,
  payload,
});

export const getReloadSchoolDetail = (payload) => ({
  type: RELOAD_SCHOOL_DETAIL,
  payload
})